import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { GALLERY } from "@/data/site";

const Gallery = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: "start" });
  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    const id = setInterval(() => emblaApi.scrollNext(), 3500);
    return () => clearInterval(id);
  }, [emblaApi]);

  return (
    <section id="gallery" data-testid="gallery-section" className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
        <div>
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-[var(--gold)]/40 bg-[var(--gold)]/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-[var(--royal-deep)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--gold)]"></span> Our Showcase
          </div>
          <h2 className="font-display text-3xl font-bold text-[var(--royal-deep)] sm:text-5xl">
            Our <span className="text-gradient-gold">premium fleet</span> in pictures
          </h2>
          <p className="mt-4 max-w-xl text-base text-muted-foreground">
            A glimpse of the vehicles you'll ride in — meticulously maintained, photographed by our team.
          </p>
        </div>
        <div className="flex gap-3">
          <button
            data-testid="gallery-prev-btn"
            aria-label="Previous slide"
            onClick={scrollPrev}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-[var(--royal)]/15 bg-white text-[var(--royal-deep)] hover:bg-[var(--gold)]/10"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            data-testid="gallery-next-btn"
            aria-label="Next slide"
            onClick={scrollNext}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-[var(--royal)]/15 bg-white text-[var(--royal-deep)] hover:bg-[var(--gold)]/10"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      <div className="overflow-hidden" ref={emblaRef} data-testid="gallery-carousel">
        <div className="flex">
          {GALLERY.map((g, i) => (
            <div className="gallery-slide" key={g.src} data-testid={`gallery-slide-${i}`}>
              <img src={g.src} alt={g.label} loading="lazy" />
              <span className="gallery-caption">{g.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
